<template>
  <base-material-card color="primary" icon="mdi-chart-multiple" title="Adicionar Analítico de CA" inline class="ml-0 px-5 py-4">
    <v-form class="mt-5">
      <v-row align="center" class="mx-auto">
        <v-col cols="12">
          <v-textarea
            id="obras-analitico-ca"
            v-model="obras"
            class="mt-0 pt-0"
            label="Obras"
            placeholder="Insira os códigos das obras, um por linha. Ex.:

CI1944457111 
CI1944457348"
            rows="5"
            no-resize
            clearable
            clear-icon="mdi-close-circle"
          />
        </v-col>
      </v-row>

      <v-row align="center" class="mx-auto">
        <v-col cols="12">
          <v-textarea
            id="tipologias-analitico-ca"
            v-model="tipologias"
            class="mt-0 pt-0"
            label="Tipologias"
            placeholder="Insira os códigos das tipologias, um código por linha. Ex.: 

RAU
RAR"
            rows="5"
            no-resize
            clearable
            clear-icon="mdi-close-circle"
          />
        </v-col>
      </v-row>

      <v-row class="mx-auto">
        <v-col cols="12">
          <v-select
            id="filto-tipo-ca"
            v-model="filtroTipoCaSelected"
            label="Filtro tipo CA"
            :items="parametrosFiltroTipoCa"
            item-text="text"
            item-value="value"
            outlined
            chips
            small-chips
            multiple
          />
        </v-col>
      </v-row>

      <v-row id="data-imobilizacao-analitico-ca" class="mx-auto" justify="space-between">
        <v-col class="pb-0 pl-2 pt-1" cols="12" sm="5">
          <v-menu
            v-model="menuPickerImob[0]"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <validation-provider
                v-slot="{ errors }"
                :rules="{ required_if: dataImob.fimFormatted != null && dataImob.fimFormatted.length > 0, min: 10 }"
              >
                <v-text-field
                  v-model="dataImob.inicioFormatted"
                  v-mask="'##/##/####'"
                  :error-messages="errors"
                  class="pt-0"
                  label="Data Imobilização"
                  prepend-icon="mdi-calendar"
                  clearable
                  v-bind="attrs"
                  v-on="on"
                  @blur="dataImob.inicio = parseDate(dataImob.inicioFormatted)"
                />
              </validation-provider>
            </template>
            <v-date-picker
              v-model="dataImob.inicio"
              locale="pt-br"
              @input="
                menuPickerImob[0] = false;
                dataImob.inicioFormatted = formatDate(dataImob.inicio);
              "
            />
          </v-menu>
        </v-col>
        <v-col class="pt-5 text-center" style="min-width: 60px !important" cols="12" sm="1">
          <span style="color: rgba(0, 0, 0, 0.54); font-size: 15px">até</span>
        </v-col>
        <v-col class="pb-0 pl-2 pt-1" cols="12" sm="5">
          <v-menu
            v-model="menuPickerImob[1]"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <validation-provider
                v-slot="{ errors }"
                :rules="{
                  required_if: dataImob.inicioFormatted != null && dataImob.inicioFormatted.length > 0,
                  min: 10
                }"
              >
                <v-text-field
                  v-model="dataImob.fimFormatted"
                  v-mask="'##/##/####'"
                  :error-messages="errors"
                  class="pt-0"
                  label="Data Imobilização"
                  prepend-icon="mdi-calendar"
                  clearable
                  v-bind="attrs"
                  v-on="on"
                  @blur="dataImob.fim = parseDate(dataImob.fimFormatted)"
                />
              </validation-provider>
            </template>
            <v-date-picker
              v-model="dataImob.fim"
              locale="pt-br"
              @input="
                menuPickerImob[1] = false;
                dataImob.fimFormatted = formatDate(dataImob.fim);
              "
            />
          </v-menu>
        </v-col>
      </v-row>

      <v-row id="flags-analitico-ca" class="mx-auto" justify="space-between">
        <v-col cols="12" sm="5">
          <v-select v-model="flag1" :items="flagsValueList" hide-details label="Flag 1: Obra com UAR <= 10%" />
        </v-col>

        <v-col cols="12" sm="5">
          <v-select v-model="flag2" :items="flagsValueList" hide-details label="Flag 2: Flag 90" />
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>
  import DateFormatterMixins from '@/mixins/dateFormatterMixins.js';

  export default {
    name: 'ParametrosAnaliticosCA',

    mixins: [DateFormatterMixins],

    data() {
      return {
        obras: '',
        tipologias: '',
        parametrosFiltroTipoCa: [
          { value: 'Frete/Transporte', text: 'Frete/Transporte' },
          { value: 'Projeto', text: 'Projeto' },
          { value: 'Gerenciamento', text: 'Gerenciamento' },
          { value: 'Fiscalização', text: 'Fiscalização' },
          { value: 'Montagem', text: 'Montagem' },
          { value: 'Custo de Suporte', text: 'Custo de Suporte' }
        ],
        filtroTipoCaSelected: [],
        dataImob: {
          inicioFormatted: '',
          inicio: '',
          fimFormatted: '',
          fim: ''
        },
        menuPickerImob: [false, false],
        flag1: '',
        flag2: '',
        flagsValueList: [
          { value: '', text: 'Todas as linhas' },
          { value: 0, text: 'Somente linhas que falharam' },
          { value: 1, text: 'Somente linhas aprovadas' }
        ]
      };
    },

    methods: {
      exportData() {
        return {
          calculo_id: this.$route.params.id,
          filtros: {
            obras: this.obras,
            tipologias: this.tipologias,
            filtroTipoCa: this.filtroTipoCaSelected,
            dataImobilizacaoInicial: this.dataImob.inicioFormatted,
            dataImobilizacaoFinal: this.dataImob.fimFormatted,
            flags: {
              FLG_ODI_UAR_ZERO: this.flag1,
              FLG_ERR_DT_LMTO: this.flag2
            }
          }
        };
      }
    }
  };
</script>

<style></style>
